import api from './api';

const reportService = {
  getFinancialSummary: async (startDate, endDate) => {
    let url = '/reports/financial';
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await api.get(url);
    return response.data;
  },
  getStockReport: async () => {
    const response = await api.get('/reports/stock');
    return response.data;
  },
  getTopProducts: async (startDate, endDate) => {
    let url = '/reports/top-products';
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await api.get(url);
    return response.data;
  },
  getTopDealers: async (startDate, endDate) => {
    let url = '/reports/top-dealers';
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await api.get(url);
    return response.data;
  }
};

export default reportService;
